module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "offset-lg-2 col-lg-8 col-sm-12"
  }, [_c('div', {
    staticClass: "step-form__main pt-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-sm-12"
  }, [(_vm.frontAppliedProductId == 10000057823975) ? _c('span', {
    staticClass: "step-text-active"
  }, [_vm._v("Equipment Details")]) : _c('span', {
    staticClass: "step-text-active"
  }, [_vm._v("Financial Review")])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.frontAppliedProductId == 10000057823975) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "uploadForm",
    staticClass: "step-form__form",
    attrs: {
      "model": _vm.uploadForm
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Vendor name",
      "prop": "vendorName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Vendor name"
    },
    model: {
      value: (_vm.uploadForm.vendorName),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "vendorName", $$v)
      },
      expression: "uploadForm.vendorName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phone",
      "prop": "vendorPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.vendorPhone),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "vendorPhone", $$v)
      },
      expression: "uploadForm.vendorPhone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Vendor address",
      "prop": "vendorAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": 40
    },
    model: {
      value: (_vm.uploadForm.vendorAddress),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "vendorAddress", $$v)
      },
      expression: "uploadForm.vendorAddress"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "City",
      "prop": "vendorCity"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": 30
    },
    model: {
      value: (_vm.uploadForm.vendorCity),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "vendorCity", $$v)
      },
      expression: "uploadForm.vendorCity"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "State",
      "prop": "vendorState"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select state"
    },
    model: {
      value: (_vm.uploadForm.vendorState),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "vendorState", $$v)
      },
      expression: "uploadForm.vendorState"
    }
  }, _vm._l((_vm.stateS), function(item) {
    return _c('el-option', {
      key: item.text,
      attrs: {
        "label": item.text,
        "value": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Zip code",
      "prop": "vendorZipCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "5-digit postal code",
      "maxlength": 5
    },
    model: {
      value: (_vm.uploadForm.vendorZipCode),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "vendorZipCode", $$v)
      },
      expression: "uploadForm.vendorZipCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Equipment amount",
      "prop": "equipmentAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.equipmentAmount),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "equipmentAmount", $$v)
      },
      expression: "uploadForm.equipmentAmount"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Equipment status",
      "prop": "equipmentStatus"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Equipment status"
    },
    model: {
      value: (_vm.uploadForm.equipmentStatus),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "equipmentStatus", $$v)
      },
      expression: "uploadForm.equipmentStatus"
    }
  }, _vm._l((_vm.status), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "margin-bottom-0",
    attrs: {
      "label": "Equipment description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.uploadForm.equipmentDesc),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "equipmentDesc", $$v)
      },
      expression: "uploadForm.equipmentDesc"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "margin-left": "10%",
      "width": "80%",
      "padding-left": "5px"
    }
  }, [_vm._v("Bank statements")])]), _vm._v(" "), _c('h3', {
    staticClass: "step-form__title",
    staticStyle: {
      "padding-bottom": "38px",
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "12px",
      "line-height": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n                Please attach last six months’ business bank statements (typically 1st page only with activity summary sections required)")]), _vm._v(" "), (!_vm.dialogVisible) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Choose File")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded"
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "margin-left": "10%",
      "width": "80%",
      "padding-left": "5px"
    }
  }, [_vm._v("Equipment invoices/titles")])]), _vm._v(" "), _c('h3', {
    staticClass: "step-form__title",
    staticStyle: {
      "padding-bottom": "38px",
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "12px",
      "line-height": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n                Please attach a copy of recent monthly payment statement(s) for any term loan or equipment leases")]), _vm._v(" "), (!_vm.dialogVisible2) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess2,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Choose File")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded2"
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible2),
      callback: function($$v) {
        _vm.dialogVisible2 = $$v
      },
      expression: "dialogVisible2"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl2,
      "alt": ""
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.frontAppliedProductId == 10000057880003) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "uploadForm",
    staticClass: "step-form__form",
    attrs: {
      "model": _vm.uploadForm
    }
  }, [_c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px"
    }
  }, [_vm._v("Billing information")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Average monthly billing",
      "prop": "averageMonthlyBilling"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.averageMonthlyBilling),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "averageMonthlyBilling", $$v)
      },
      expression: "uploadForm.averageMonthlyBilling"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Desired factoring amount",
      "prop": "desiredFactoringAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.desiredFactoringAmount),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "desiredFactoringAmount", $$v)
      },
      expression: "uploadForm.desiredFactoringAmount"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Average invoice size",
      "prop": "averageInvoiceSize"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.averageInvoiceSize),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "averageInvoiceSize", $$v)
      },
      expression: "uploadForm.averageInvoiceSize"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Largest invoice",
      "prop": "largestInvoice"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.largestInvoice),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "largestInvoice", $$v)
      },
      expression: "uploadForm.largestInvoice"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Smallest invoice",
      "prop": "smallestInvoice"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.smallestInvoice),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "smallestInvoice", $$v)
      },
      expression: "uploadForm.smallestInvoice"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Do you bill in progress stages?",
      "prop": "anyBillInProgress"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anyBillInProgress),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyBillInProgress", $$v)
      },
      expression: "uploadForm.anyBillInProgress"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Are any sales bill and hold?",
      "prop": "anySalesBillHold"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anySalesBillHold),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anySalesBillHold", $$v)
      },
      expression: "uploadForm.anySalesBillHold"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px"
    }
  }, [_vm._v("Customer information")])]), _vm._v(" "), _c('el-row', [_c('h4', {
    staticStyle: {
      "text-align": "left",
      "color": "#33475b",
      "padding-left": "5px"
    }
  }, [_vm._v("Customer#1")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Legal business name",
      "prop": "customerBusinessName1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerBusinessName1),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerBusinessName1", $$v)
      },
      expression: "uploadForm.customerBusinessName1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "customerEmail1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerEmail1),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerEmail1", $$v)
      },
      expression: "uploadForm.customerEmail1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "customerAddress1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerAddress1),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerAddress1", $$v)
      },
      expression: "uploadForm.customerAddress1"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phone",
      "prop": "customerPhone1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.customerPhone1),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerPhone1", $$v)
      },
      expression: "uploadForm.customerPhone1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Fax",
      "prop": "customerFax1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.customerFax1),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerFax1", $$v)
      },
      expression: "uploadForm.customerFax1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Website",
      "prop": "customerWebsite1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerWebsite1),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerWebsite1", $$v)
      },
      expression: "uploadForm.customerWebsite1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Payment terms",
      "prop": "customerPaymentTerms1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerPaymentTerms1),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerPaymentTerms1", $$v)
      },
      expression: "uploadForm.customerPaymentTerms1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Current balance",
      "prop": "customerCurrentBalance1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.customerCurrentBalance1),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerCurrentBalance1", $$v)
      },
      expression: "uploadForm.customerCurrentBalance1"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', {
    staticStyle: {
      "text-align": "left",
      "color": "#33475b",
      "padding-left": "5px"
    }
  }, [_vm._v("Customer#2")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Legal business name",
      "prop": "customerBusinessName2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerBusinessName2),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerBusinessName2", $$v)
      },
      expression: "uploadForm.customerBusinessName2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "customerEmail2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerEmail2),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerEmail2", $$v)
      },
      expression: "uploadForm.customerEmail2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "customerAddress2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerAddress2),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerAddress2", $$v)
      },
      expression: "uploadForm.customerAddress2"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phone",
      "prop": "customerPhone2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.customerPhone2),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerPhone2", $$v)
      },
      expression: "uploadForm.customerPhone2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Fax",
      "prop": "customerFax2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.customerFax2),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerFax2", $$v)
      },
      expression: "uploadForm.customerFax2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Website",
      "prop": "customerWebsite2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerWebsite2),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerWebsite2", $$v)
      },
      expression: "uploadForm.customerWebsite2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Payment terms",
      "prop": "customerPaymentTerms2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerPaymentTerms2),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerPaymentTerms2", $$v)
      },
      expression: "uploadForm.customerPaymentTerms2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Current balance",
      "prop": "customerCurrentBalance2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.customerCurrentBalance2),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerCurrentBalance2", $$v)
      },
      expression: "uploadForm.customerCurrentBalance2"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', {
    staticStyle: {
      "text-align": "left",
      "color": "#33475b",
      "padding-left": "5px"
    }
  }, [_vm._v("Customer#3")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Legal business name",
      "prop": "customerBusinessName3"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerBusinessName3),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerBusinessName3", $$v)
      },
      expression: "uploadForm.customerBusinessName3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "customerEmail3"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerEmail3),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerEmail3", $$v)
      },
      expression: "uploadForm.customerEmail3"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "customerAddress3"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerAddress3),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerAddress3", $$v)
      },
      expression: "uploadForm.customerAddress3"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phone",
      "prop": "customerPhone3"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.customerPhone3),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerPhone3", $$v)
      },
      expression: "uploadForm.customerPhone3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Fax",
      "prop": "customerFax3"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.customerFax3),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerFax3", $$v)
      },
      expression: "uploadForm.customerFax3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Website",
      "prop": "customerWebsite3"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerWebsite3),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerWebsite3", $$v)
      },
      expression: "uploadForm.customerWebsite3"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Payment terms",
      "prop": "customerPaymentTerms3"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerPaymentTerms3),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerPaymentTerms3", $$v)
      },
      expression: "uploadForm.customerPaymentTerms3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Current balance",
      "prop": "customerCurrentBalance3"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.customerCurrentBalance3),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerCurrentBalance3", $$v)
      },
      expression: "uploadForm.customerCurrentBalance3"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', {
    staticStyle: {
      "text-align": "left",
      "color": "#33475b",
      "padding-left": "5px"
    }
  }, [_vm._v("Customer#4")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Legal business name",
      "prop": "customerBusinessName4"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerBusinessName4),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerBusinessName4", $$v)
      },
      expression: "uploadForm.customerBusinessName4"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "customerEmail4"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerEmail4),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerEmail4", $$v)
      },
      expression: "uploadForm.customerEmail4"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "customerAddress4"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerAddress4),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerAddress4", $$v)
      },
      expression: "uploadForm.customerAddress4"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phone",
      "prop": "customerPhone4"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.customerPhone4),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerPhone4", $$v)
      },
      expression: "uploadForm.customerPhone4"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Fax",
      "prop": "customerFax4"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.customerFax4),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerFax4", $$v)
      },
      expression: "uploadForm.customerFax4"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Website",
      "prop": "customerWebsite4"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerWebsite4),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerWebsite4", $$v)
      },
      expression: "uploadForm.customerWebsite4"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Payment terms",
      "prop": "customerPaymentTerms4"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerPaymentTerms4),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerPaymentTerms4", $$v)
      },
      expression: "uploadForm.customerPaymentTerms4"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Current balance",
      "prop": "customerCurrentBalance4"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.customerCurrentBalance4),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerCurrentBalance4", $$v)
      },
      expression: "uploadForm.customerCurrentBalance4"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', {
    staticStyle: {
      "text-align": "left",
      "color": "#33475b",
      "padding-left": "5px"
    }
  }, [_vm._v("Customer#5")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Legal business name",
      "prop": "customerBusinessName5"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerBusinessName5),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerBusinessName5", $$v)
      },
      expression: "uploadForm.customerBusinessName5"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "customerEmail5"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerEmail5),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerEmail5", $$v)
      },
      expression: "uploadForm.customerEmail5"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "customerAddress5"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerAddress5),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerAddress5", $$v)
      },
      expression: "uploadForm.customerAddress5"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phone",
      "prop": "customerPhone5"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.customerPhone5),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerPhone5", $$v)
      },
      expression: "uploadForm.customerPhone5"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Fax",
      "prop": "customerFax5"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.customerFax5),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerFax5", $$v)
      },
      expression: "uploadForm.customerFax5"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Website",
      "prop": "customerWebsite5"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerWebsite5),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerWebsite5", $$v)
      },
      expression: "uploadForm.customerWebsite5"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Payment terms",
      "prop": "customerPaymentTerms5"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.customerPaymentTerms5),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerPaymentTerms5", $$v)
      },
      expression: "uploadForm.customerPaymentTerms5"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Current balance",
      "prop": "customerCurrentBalance5"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.customerCurrentBalance5),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "customerCurrentBalance5", $$v)
      },
      expression: "uploadForm.customerCurrentBalance5"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Do you have any outstanding loans/advances?",
      "prop": "anyOutstandingLoans"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anyOutstandingLoans),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyOutstandingLoans", $$v)
      },
      expression: "uploadForm.anyOutstandingLoans"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Is your inventory/receivables pledged as collateral?",
      "prop": "ifReceivablesAsCollateral"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.ifReceivablesAsCollateral),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "ifReceivablesAsCollateral", $$v)
      },
      expression: "uploadForm.ifReceivablesAsCollateral"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name of financial institution",
      "prop": "nameOfFinancialInstitution"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.nameOfFinancialInstitution),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "nameOfFinancialInstitution", $$v)
      },
      expression: "uploadForm.nameOfFinancialInstitution"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Loan amount and terms",
      "prop": "loanAmountAndTerms"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.loanAmountAndTerms),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "loanAmountAndTerms", $$v)
      },
      expression: "uploadForm.loanAmountAndTerms"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Are your federal, state, & payroll taxes current?",
      "prop": "ifCurrentTaxesPaid"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.ifCurrentTaxesPaid),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "ifCurrentTaxesPaid", $$v)
      },
      expression: "uploadForm.ifCurrentTaxesPaid"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "If No: Federal taxes owed?",
      "prop": "federalTaxesOwed"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.federalTaxesOwed),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "federalTaxesOwed", $$v)
      },
      expression: "uploadForm.federalTaxesOwed"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "State taxes owed?",
      "prop": "stateTaxesOwed"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.stateTaxesOwed),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "stateTaxesOwed", $$v)
      },
      expression: "uploadForm.stateTaxesOwed"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Any liens been placed?",
      "prop": "anyLiensPlaced"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anyLiensPlaced),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyLiensPlaced", $$v)
      },
      expression: "uploadForm.anyLiensPlaced"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Are you on a payment plan?",
      "prop": "anyPaymentPlan"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anyPaymentPlan),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyPaymentPlan", $$v)
      },
      expression: "uploadForm.anyPaymentPlan"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Monthly payment",
      "prop": "monthlyPayment"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.monthlyPayment),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "monthlyPayment", $$v)
      },
      expression: "uploadForm.monthlyPayment"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px"
    }
  }, [_vm._v("Legal information")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Is the company or any officer involved in any type of litigation or lawsuit?",
      "prop": "anyLawsuit"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anyLawsuit),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyLawsuit", $$v)
      },
      expression: "uploadForm.anyLawsuit"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Company attorney",
      "prop": "companyAttorney"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.companyAttorney),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "companyAttorney", $$v)
      },
      expression: "uploadForm.companyAttorney"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Attorney phone",
      "prop": "companyAttorneyPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.companyAttorneyPhone),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "companyAttorneyPhone", $$v)
      },
      expression: "uploadForm.companyAttorneyPhone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Company accountant",
      "prop": "companyAccountant"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.companyAccountant),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "companyAccountant", $$v)
      },
      expression: "uploadForm.companyAccountant"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Accountant phone",
      "prop": "companyAccountantPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.companyAccountantPhone),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "companyAccountantPhone", $$v)
      },
      expression: "uploadForm.companyAccountantPhone"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "margin-left": "10%",
      "width": "80%",
      "padding-left": "5px"
    }
  }, [_vm._v("Supporting documents")])]), _vm._v(" "), _c('h3', {
    staticClass: "step-form__title",
    staticStyle: {
      "padding-bottom": "38px",
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "12px",
      "line-height": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n                Please attach last six months’ business bank statements (typically 1st page only with activity summary sections required)")]), _vm._v(" "), (!_vm.dialogVisible) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Choose File")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded"
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "step-form__title",
    staticStyle: {
      "padding-bottom": "38px",
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "12px",
      "line-height": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n            Detailed accounts payable aging")]), _vm._v(" "), (!_vm.dialogVisible3) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess3,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Choose File")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded3"
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible3),
      callback: function($$v) {
        _vm.dialogVisible3 = $$v
      },
      expression: "dialogVisible3"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl3,
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "step-form__title",
    staticStyle: {
      "padding-bottom": "38px",
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "12px",
      "line-height": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n            Articles of incorporation & operating agreement")]), _vm._v(" "), (!_vm.dialogVisible4) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess4,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Choose File")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded4"
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible4),
      callback: function($$v) {
        _vm.dialogVisible4 = $$v
      },
      expression: "dialogVisible4"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl4,
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "step-form__title",
    staticStyle: {
      "padding-bottom": "38px",
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "12px",
      "line-height": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n            Customer contracts and/or purchase orders")]), _vm._v(" "), (!_vm.dialogVisible5) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess5,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Choose File")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded5"
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible5),
      callback: function($$v) {
        _vm.dialogVisible5 = $$v
      },
      expression: "dialogVisible5"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl5,
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "step-form__title",
    staticStyle: {
      "padding-bottom": "38px",
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "12px",
      "line-height": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n            Detailed accounts receivable aging")]), _vm._v(" "), (!_vm.dialogVisible6) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess6,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Choose File")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded6"
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible6),
      callback: function($$v) {
        _vm.dialogVisible6 = $$v
      },
      expression: "dialogVisible6"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl6,
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "step-form__title",
    staticStyle: {
      "padding-bottom": "38px",
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "12px",
      "line-height": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n            Sample invoice with backup documentation (e.g. proof of delivery, inspection, time sheets, or performance proof)")]), _vm._v(" "), (!_vm.dialogVisible7) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess7,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Choose File")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded7"
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible7),
      callback: function($$v) {
        _vm.dialogVisible7 = $$v
      },
      expression: "dialogVisible7"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl7,
      "alt": ""
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.frontAppliedProductId == 10000058170080) ? _c('div', [_c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "margin-left": "10%",
      "width": "80%",
      "padding-left": "5px"
    }
  }, [_vm._v("PPP REQUIRED DOCUMENTS")])]), _vm._v(" "), _c('h3', {
    staticClass: "step-form__title",
    staticStyle: {
      "padding-bottom": "10px",
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "24px",
      "line-height": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n            1. PPP Borrower Application Form (revised 1.8.2021)-508")]), _vm._v(" "), _vm._m(3), _vm._v(" "), (!_vm.dialogVisible) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess8,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Choose File")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded8"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "step-form__title",
    staticStyle: {
      "padding-bottom": "38px",
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "24px",
      "line-height": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n            2. Driver’s License / Photo ID")]), _vm._v(" "), (!_vm.dialogVisible) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess9,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Choose File")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded9"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "step-form__title",
    staticStyle: {
      "padding-bottom": "38px",
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "24px",
      "line-height": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n            3. Voided Check")]), _vm._v(" "), (!_vm.dialogVisible3) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess10,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Choose File")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded10"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "step-form__title",
    staticStyle: {
      "padding-bottom": "10px",
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "24px",
      "line-height": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n            4. Bank Statements")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Please provide a bank statement that covers 2/15/2020 as proof that the Applicant was in business as of 2/15/2020. If available, bank statements that are downloaded from your bank’s website will work better than scanned versions.")]), _vm._v(" "), (!_vm.dialogVisible4) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess11,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Choose File")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded11"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "step-form__title",
    staticStyle: {
      "padding-bottom": "10px",
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "24px",
      "line-height": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n            5. Form 1120 or 1120-S")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("To substantiate health insurance (line 24 of 1120 or line 18 of 1120-S) or retirement benefits (line 23 of 1120 or line 17 of 1120-S) to employees.")]), _vm._v(" "), (!_vm.dialogVisible5) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess12,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Choose File")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded12"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "step-form__title",
    staticStyle: {
      "padding-bottom": "10px",
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "24px",
      "line-height": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n            6. Proof of Payroll Form 940")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "red"
    }
  }, [_vm._v("*Applicable only if you have employees*")]), _vm._v(" "), (!_vm.dialogVisible6) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess13,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Choose File")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded13"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "step-form__title",
    staticStyle: {
      "padding-bottom": "38px",
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "24px",
      "line-height": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n            7. Form 1040 Schedule C")]), _vm._v(" "), (!_vm.dialogVisible7) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess14,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Choose File")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded14"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    staticClass: "step-form__form"
  }, [_c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px",
      "margin-bottom": "20px"
    }
  }, [_vm._v("Declaration")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#33475b",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "400",
      "font-size": "14px",
      "line-height": "24px",
      "text-align": "left"
    }
  }, [_vm._v("\n                The undersigned individual, on behalf of themselves and all others listed on this application, recognizing that their individual, as well as their company, credit history may be a factor in the evaluation of the credit of the applicant, hereby consents to and authorizes American Credit, Inc and any assignee, lender, or funding service that may be utilized to obtain and use a consumer credit report on the undersigned, now and from time to time, as needed in the credit evaluation and review process, and waives any right or claim they would otherwise have under Fair Credit Reporting Act in the absence of this continuing consent.\n                ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#33475b",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "400",
      "font-size": "14px",
      "line-height": "24px",
      "text-align": "left"
    }
  }, [_vm._v("\n                To help the government fight the funding of terrorism and money laundering activities, Federal Law requires all financial institutions to obtain, verify, and record information that identifies each person who opens an account. What this means for you: When you open an account, we will ask for your name, address, date of birth (for individuals) and other information that will allow us to identify you. We may also ask to see your driver’s license (for individuals) or other identifying documents.\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "step-form__btn-container"
  }, [_c('el-button', {
    staticClass: "rounded-pill bluebg px-5",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/personalCenter'
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('el-button', {
    staticClass: "rounded-pill bluebg px-5",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.goNext
    }
  }, [_vm._v("Next")])], 1), _vm._v(" "), _c('br')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-sm-12"
  }, [_c('span', [_vm._v("Business Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-sm-12"
  }, [_c('span', [_vm._v("Personal Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 col-sm-12"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "tel:855-904-0188"
    }
  }, [_c('i', {
    staticClass: "phone-icon fa fa-phone",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                855-904-0188\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "../../../static/PPP Borrower Application Form (revised 1.8.2021)-508.pdf",
      "target": "blank"
    }
  }, [_vm._v("Click here to download 【PPP Borrower Application Form (revised 1.8.2021)-508】")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1be4c48c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/applyLoan/upload.vue
// module id = 1947
// module chunks = 5